import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../lib/api";
import useSEO from "../lib/useSEO";

export default function Blog() {
    useSEO({ title: "Insights", description: "Commentary, casework and analysis on Nigerian law from the partners and associates of Rotimi Jacobs & Co.", path: "/blog" });
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/blog").then(({ data }) => { setPosts(data); setLoading(false); }).catch(() => setLoading(false));
    }, []);

    return (
        <div data-testid="page-blog">
            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24">
                <div className="font-mono-cap text-xs text-[#c5a059] mb-3">Insights</div>
                <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-tight">
                    Commentary, casework and the state of Nigerian law.
                </h1>
            </section>

            <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
                {loading ? (
                    <div className="font-mono-cap text-xs text-slate-500">Loading…</div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {posts.map((p) => (
                            <Link
                                key={p.id}
                                to={`/blog/${p.slug}`}
                                className="group block border border-slate-900/10 bg-[#faf9f6] hover:border-[#c5a059] transition-colors"
                                data-testid={`blog-card-${p.slug}`}
                            >
                                {p.cover_url && (
                                    <div className="h-52 overflow-hidden">
                                        <img src={p.cover_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                                    </div>
                                )}
                                <div className="p-7">
                                    <div className="font-mono-cap text-[11px] text-[#c5a059]">{p.category}</div>
                                    <h2 className="font-serif-display text-2xl text-slate-900 mt-2 leading-tight">{p.title}</h2>
                                    <p className="mt-3 text-[15px] text-slate-800 leading-relaxed">{p.excerpt}</p>
                                    <div className="mt-6 inline-flex items-center gap-2 text-sm font-medium border-b border-[#c5a059] pb-1">
                                        Read <ArrowUpRight className="w-4 h-4" />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
